import {View} from '@fantasmagames/slot/src/common/view/View';
import {Position} from '@fantasmagames/slot/src/modules/reels/ReelConstants';
import {SpineAnimation} from '@fantasmagames/core/src/display/SpineAnimation';

export class LogotypeView extends View {
	public static readonly LOGOTYPE_DOUBLE_TAPPED: string = 'LogotypeView::LOGOTYPE_DOUBLE_TAPPED';

	public init(): void {
		super.init();

		this.setupLogotype();
	}

	protected shouldReplaceLogoElement(): boolean {
		return (
			this.resources
				.getLocale()
				.toLowerCase()
				.indexOf('zh') > -1
		);
	}

	protected getLocale(): string {
		let locale = this.resources.getLocale().toUpperCase();

		if (locale.indexOf('ZH') > -1) {
			locale = locale.split('-').join('_');
		}

		return locale;
	}

	protected setupLogotype(): void {
		const position: Position = this.layout.getAbsolutePosition('GAME_LOGO', this.viewType);
		const logo: SpineAnimation = this.spineUtils
			.startSpineAnimationCreation('LOGOTYPE.json', 'IDLE', true)
			.position(position)
			.createAndStart();

		if (this.shouldReplaceLogoElement()) {
			this.spineUtils.replaceElementInSpineAnimation(
				logo,
				'LOGO',
				new PIXI.Sprite(this.resources.getTexture(`LOGO_${this.getLocale()}.png`)),
			);
		}

		if (!__PRODUCTION__) {
			if (this.device.isMobile) {
				logo.container.interactive = logo.container.buttonMode = true;
				let lastTap: number = 0;
				let timeout = null;

				logo.container.on('touchend', () => {
					const currentTime = new Date().getTime();
					const tapLength = currentTime - lastTap;
					clearTimeout(timeout);

					if (tapLength < 500 && tapLength > 0) {
						this.emit(LogotypeView.LOGOTYPE_DOUBLE_TAPPED);
						lastTap = 0;
					} else {
						timeout = setTimeout(() => {
							clearTimeout(timeout);
						}, 500);

						lastTap = currentTime;
					}
				});
			}
		}
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/logotype/LogotypeView.ts